var map = {
	"./beta.svg": 36442,
	"./burger-icon.svg": 65783,
	"./doc-icon.svg": 56760,
	"./farm-icon.svg": 77618,
	"./home-icon.svg": 82013,
	"./labs-icon.svg": 88386,
	"./pool-icon.svg": 42888,
	"./swap-icon.svg": 3337,
	"./universe-icon.png": 25297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76332;